import React, { useContext } from 'react';
import { RouteContext } from '../../contexts';
import { makeStyles, Paper } from '@material-ui/core';
import { useIsMobile } from '../../helpers/devices';

const useStyles = makeStyles((theme) => ({
  embeddedIframeContainer: {
    display: 'block',
    marginTop: '-35px',
    marginLeft: '-20px',
    width: '94vw',
    height: 'calc(100% + 35px)', // offset for negative margin

    [theme.breakpoints.down('sm')]: {
      marginLeft: '-15px',
      width: '100vw'
    },

    '& iframe': {
      border: 0,
      width: '100%',
      height: '100%',
      minHeight: '1000px'
    }
  }
}));


export const EmbeddableIframe: React.FC = () => {
  const classes = useStyles();
  const routeCtx = useContext(RouteContext);

  return (
    <Paper className={classes.embeddedIframeContainer}>
      {useIsMobile() ? (
        <iframe src={routeCtx.info.data} />
      ) : (
        <iframe src={routeCtx.info.data} scrolling="no"/>
      )}
    </Paper>
  );
};

export default EmbeddableIframe;
